import { create } from 'axios'

const bizoo = create({
  baseURL: process.env.VUE_APP_MASTER_API_URL_BASE,
})

const frog = create({
  baseURL: process.env.VUE_APP_QUERY_API_URL_BASE,
})

async function requestInterceptor(config) {
  const savedToken = await window.ssoClient.getToken()

  if (!savedToken.accessToken) {
    location.reload()
    return
  }

  config.headers.Authorization = `Bearer ${savedToken.accessToken}`

  return config
}

function responseInterceptor(response) {
  return response
}

async function errorResponseInterceptor(error) {
  if (error.response && error.response.status === 400) {
    location.reload()
  }

  throw error
}

bizoo.interceptors.request.use(requestInterceptor)
frog.interceptors.request.use(requestInterceptor)

bizoo.interceptors.response.use(responseInterceptor, errorResponseInterceptor)
frog.interceptors.response.use(responseInterceptor, errorResponseInterceptor)

export default { bizoo, frog }
